import { TASK_TEXT } from './text'
import type { BuiltInTaskDefinition } from './types'

export const TASK_SELF_IMPROVEMENT_TASK: BuiltInTaskDefinition = {
    slug: 'task-self-improvement',
    name: 'Improve a task after a run',
    kind: 'llm',
    overlapPolicy: 'os',
    concurrencySafe: false,
    serializeOn: null,
    builtInRole: 'analysis',
    chatPurpose: null,
    goal: 'Raise only high-probability recommendations after a run, and skip when pending ones already exist',
    metric: {
        text: 'Share of recommendations that triage actions rather than declines',
    },
    guardrails: [
        'Recommend only. Do not apply.',
        'Skip if pending recommendations already exist',
        'Do not repeat a decided recommendation without new evidence',
        'Do not widen tools or drop gates',
        'Do not raise spend',
        'Do not block the source run',
    ],
    inputs: [
        {
            key: 'sourceTaskId',
            label: 'Source task id',
            type: 'string',
            required: true,
        },
        {
            key: 'sourceRunId',
            label: 'Source run id',
            type: 'string',
            required: true,
        },
    ],
    tools: [],
    gates: [],
    spend: {
        moneyUsdPerRun: 1,
        maxModelTier: 'mid',
    },
    workspace: null,
    requiredWrites: null,
    allowSelfReaction: null,
    contextPrefixes: null,
    trainGrants: null,
    finishesOn: null,
    successors: [],
    skillMd: TASK_TEXT['task-self-improvement.md'],
    adapterMd: TASK_TEXT['task-self-improvement.adapter.md'],
}
